import * as jsxRuntime from "/home/ec2-user/workspace/AFL_Mint_Website_master@2/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment